export interface HeroCard {
  tag: string;
  title: string;
  summary: string;
  image: string;
  meta: string;
}

export interface RankingItem {
  rank: number;
  title: string;
  heat: number;
  trend: string;
  category: string;
}

export interface CollectionItem {
  title: string;
  count: string;
  note: string;
  image: string;
}

export interface LeakItem {
  title: string;
  summary: string;
  category: string;
  time: string;
}

export interface TimelineItem {
  time: string;
  title: string;
  note: string;
}

export interface StatItem {
  value: string;
  label: string;
  note: string;
}

export const heroCards: HeroCard[] = [
  {
    tag: '独家深挖',
    title: '某爆款剧组连夜换角，三方口径为何对不上',
    summary: '从片场通告单到宣发口径，我们把四条互相矛盾的时间线摆在一起看，那些被刻意留白的空档，恰恰是最值得追问的部分。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20scattered%20confidential%20folders%20and%20an%20unmarked%20envelope%20on%20a%20dark%20charcoal%20table%2C%20deep%20crimson%20and%20warm%20amber%20rim%20light%2C%20thin%20smoke%20haze%2C%20cinematic%20mysterious%20mood%2C%20minimal%20composition%20with%20generous%20negative%20space%2C%20subtle%20film%20grain%2C%20moody%20low-key%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=800&height=620&seq=gossip-hero-01&orientation=landscape',
    meta: '专题合集 · 共 12 条线索',
  },
  {
    tag: '内幕追踪',
    title: '后台走廊的三分钟，被剪掉的那段究竟拍了什么',
    summary: '一份残缺的现场记录、两个互相矛盾的目击版本，我们把公开物料逐帧排开，只为还原那条被稀释的动线。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20backstage%20corridor%20at%20night%2C%20blurred%20warm%20tungsten%20lights%20and%20long%20crimson%20shadows%20across%20a%20bare%20wall%2C%20a%20single%20spotlight%20on%20an%20empty%20chair%2C%20cinematic%20editorial%20photography%2C%20deep%20red%20and%20antique%20gold%20palette%2C%20minimal%20restrained%20composition%2C%20soft%20film%20grain%2C%20mysterious%20narrative%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=620&seq=gossip-hero-02&orientation=landscape',
    meta: '热度上升 · 今日 8.6 万阅读',
  },
  {
    tag: '猛料回顾',
    title: '一叠旧照回流，把三年前的旧账又翻了出来',
    summary: '看似无关的几张旧物料，却在同一条时间线上反复咬合，我们顺着照片流出的顺序，重新排了一遍前后因果。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20close-up%20of%20an%20old%20cassette%20recorder%20and%20stacked%20telephoto%20photographs%20on%20a%20warm%20sand%20colored%20desk%2C%20deep%20crimson%20accent%20glow%2C%20single%20directional%20light%2C%20cinematic%20editorial%20still%20life%2C%20minimal%20layered%20composition%2C%20rich%20shadows%2C%20subtle%20grain%2C%20mysterious%20investigative%20mood%2C%20no%20text%2C%20no%20people&width=800&height=620&seq=gossip-hero-03&orientation=landscape',
    meta: '私密爆料汇总 · 更新于 3 小时前',
  },
];

export const rankingItems: RankingItem[] = [
  { rank: 1, title: 'M 姓制片人深夜会面，合作名单临时生变', heat: 9860, trend: '↑ 12%', category: '资本暗线' },
  { rank: 2, title: '某古装大制作二次补拍，档期被压缩至六天', heat: 8720, trend: '↑ 9%', category: '剧组风波' },
  { rank: 3, title: '合约到期前的最后一纸补充协议流向成谜', heat: 8140, trend: '↑ 7%', category: '合约迷局' },
  { rank: 4, title: '一段被删除的访谈片段，在两个平台同时消失', heat: 7680, trend: '↑ 5%', category: '舆论反转' },
  { rank: 5, title: 'H 姓导演旧作重新上架，版本却被悄悄替换', heat: 7020, trend: '↑ 4%', category: '旧照回流' },
  { rank: 6, title: '私域群里流出的两段录音，内容互为佐证', heat: 6540, trend: '→ 持平', category: '私域录音' },
  { rank: 7, title: '宣发物料前后不一，海报顺序被重新排过', heat: 5980, trend: '↓ 2%', category: '舆论反转' },
  { rank: 8, title: '剧组账目细节外泄，报销口径难以自洽', heat: 5310, trend: '↑ 3%', category: '资本暗线' },
];

export const collections: CollectionItem[] = [
  {
    title: '剧组风波',
    count: '28 条线索',
    note: '换角、补拍与临时改期，从通告单里找破绽',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20empty%20film%20set%20with%20a%20single%20director%20chair%20and%20softbox%20light%2C%20deep%20crimson%20backdrop%2C%20warm%20amber%20highlights%2C%20minimal%20restrained%20composition%2C%20editorial%20still%20life%20photography%2C%20moody%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20people%2C%20no%20text&width=760&height=760&seq=gossip-col-01&orientation=squarish',
  },
  {
    title: '资本暗线',
    count: '19 条线索',
    note: '资金、股权与那份迟迟没签的框架协议',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20stack%20of%20financial%20documents%20and%20a%20sealed%20wax%20envelope%20on%20dark%20wood%2C%20deep%20crimson%20and%20antique%20gold%20lighting%2C%20minimal%20composition%20with%20deep%20shadows%2C%20editorial%20cinematic%20photography%2C%20subtle%20grain%2C%20investigative%20mood%2C%20no%20text%2C%20no%20people&width=760&height=760&seq=gossip-col-02&orientation=squarish',
  },
  {
    title: '合约迷局',
    count: '23 条线索',
    note: '条款里的模糊地带，往往就是争议的起点',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20of%20an%20unsigned%20contract%20and%20a%20fountain%20pen%20on%20a%20warm%20beige%20desk%2C%20deep%20red%20side%20light%2C%20minimal%20negative%20space%2C%20editorial%20cinematic%20still%20life%2C%20soft%20shadows%2C%20subtle%20film%20grain%2C%20mysterious%20mood%2C%20no%20text%2C%20no%20people&width=760&height=760&seq=gossip-col-03&orientation=squarish',
  },
  {
    title: '舆论反转',
    count: '16 条线索',
    note: '同一条物料，在不同时间点读出两种意思',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20arrangement%20of%20vintage%20newspaper%20columns%20and%20torn%20paper%20edges%20on%20a%20dark%20surface%2C%20warm%20amber%20and%20crimson%20accent%20light%2C%20minimal%20editorial%20composition%2C%20cinematic%20mood%2C%20subtle%20grain%2C%20no%20text%2C%20no%20people&width=760&height=760&seq=gossip-col-04&orientation=squarish',
  },
  {
    title: '私域录音',
    count: '11 条线索',
    note: '互相佐证的两段声音，指向同一个时间点',
    image: 'https://readdy.ai/api/search-image?query=Moody%20shot%20of%20a%20small%20voice%20recorder%20and%20tangled%20earphones%20on%20dark%20velvet%2C%20deep%20crimson%20glow%2C%20single%20direction%20light%2C%20minimal%20cinematic%20still%20life%2C%20rich%20shadow%2C%20subtle%20film%20grain%2C%20mysterious%20investigative%20mood%2C%20no%20text%2C%20no%20people&width=760&height=760&seq=gossip-col-05&orientation=squarish',
  },
  {
    title: '旧照回流',
    count: '34 条线索',
    note: '照片流出的顺序，本身就是一条证据链',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20scattered%20polaroid%20style%20blank%20photos%20on%20warm%20linen%2C%20deep%20crimson%20and%20gold%20tone%20light%2C%20minimal%20layered%20composition%2C%20editorial%20cinematic%20photography%2C%20subtle%20grain%2C%20nostalgic%20mysterious%20mood%2C%20no%20text%2C%20no%20people&width=760&height=760&seq=gossip-col-06&orientation=squarish',
  },
];

export const latestLeaks: LeakItem[] = [
  {
    title: '片场临时加的那场戏，最终没有出现在成片里',
    summary: '通告单上有明确记录，但正片和预告都没有任何痕迹，我们对比了三个版本的长度差异。',
    category: '剧组风波',
    time: '2 小时前',
  },
  {
    title: '同一份通稿，两家媒体的措辞差了一个关键动词',
    summary: '细看之下，这个动词的改动直接把责任主体换了个方向，改动痕迹并未被彻底清理。',
    category: '舆论反转',
    time: '5 小时前',
  },
  {
    title: '那份补充协议的签署页，落款日期存在两种写法',
    summary: '一个写在骑缝，一个写在正文末尾，两者相差四天，正好落在项目最敏感的时间段。',
    category: '合约迷局',
    time: '昨天',
  },
  {
    title: '投资方名单更新了一次，某家公司悄悄退到二级',
    summary: '公开信息里的层级变化往往伴随着实际的决策权转移，这一次的变化同样值得留意。',
    category: '资本暗线',
    time: '昨天',
  },
  {
    title: '两段录音的背景音完全对得上，指向同一次会面',
    summary: '背景里的关门声和手机提示音高度一致，为「同一时间线」提供了新的旁证。',
    category: '私域录音',
    time: '2 天前',
  },
  {
    title: '三年前的一组旧物料被重新上传，却少了两个人物',
    summary: '上传方并非原始版权方，而删减的位置恰好避开了最具争议的那一段画面。',
    category: '旧照回流',
    time: '3 天前',
  },
];

export const timelineItems: TimelineItem[] = [
  { time: '第 1 周', title: '项目立项消息首次外流', note: '一份会议纪要出现在小范围讨论群里，措辞与后来官方口径有明显出入。' },
  { time: '第 3 周', title: '主演名单出现第一次变动', note: '宣发物料上的排序被调整，官方未作任何说明。' },
  { time: '第 6 周', title: '补拍通知下发，档期被压缩', note: '通告单显示连续六天高强度拍摄，与原有排期冲突。' },
  { time: '第 9 周', title: '合作方状态变更被公开信息捕捉', note: '同一时间点，两家关联公司的登记信息出现调整。' },
  { time: '第 12 周', title: '旧物料回流，讨论再度升温', note: '一组被删除的旧照片重新出现，讨论重心从作品转向制作过程。' },
];

export const stats: StatItem[] = [
  { value: '312', label: '在追专题', note: '持续更新的合集数量' },
  { value: '1.4 万', label: '待核实线索', note: '已归档等待交叉验证' },
  { value: '86%', label: '多源互证率', note: '至少两条独立来源支撑' },
  { value: '24h', label: '更新节奏', note: '热度榜每日刷新一轮' },
];

export const navLinks = [
  { label: '首页', href: '#top' },
  { label: '热度榜', href: '#ranking' },
  { label: '专题合集', href: '#collections' },
  { label: '最新爆料', href: '#latest' },
  { label: '独家深挖', href: '#dig' },
];

export const tickerWords = [
  '黑料网曝 独家深挖',
  '猛料 内幕 持续跟进',
  '私密爆料汇总 多源互证',
  '热度榜单 每日刷新',
  '线索归档 待核实跟进',
];